function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    viewBox: "0 0 442.91 488.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-88.594 -166.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    style: {
      fill: "currentColor"
    },
    d: "m310.06 655.31c-122.24 0-221.47-99.22-221.47-221.47 0.004-60.88 24.72-115.94 64.53-155.96l0.19 0.18c8.05-11.11 21.05-18.4 35.81-18.4 24.45 0 44.32 19.83 44.32 44.28 0 14.99-7.5 28.2-18.91 36.22l0.16 0.15c-23.93 24.1-38.91 57-38.91 93.53 0 73.7 60.11 133.54 134.16 133.54 74.04 0 134.12-59.84 134.12-133.54 0-33.34-12.54-63.58-32.9-86.93-12.12-7.91-20.19-21.53-20.19-37.07 0-24.45 19.86-44.31 44.31-44.31 11.95 0 22.75 4.83 30.72 12.53l0.62-0.62c40.06 40.05 64.88 95.32 64.88 156.4 0 122.25-99.19 221.47-221.44 221.47zm-0.03-219.93c-24.54 0-44.28-20.11-44.28-45.1v-178.66c0-24.99 19.74-45.09 44.28-45.09s44.31 20.1 44.31 45.09v178.66c0 24.99-19.77 45.1-44.31 45.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/powerIcon.50285dcf.svg";
export { ForwardRef as ReactComponent };